




















import { PropType, defineComponent } from '@vue/composition-api';

import { IFieldErrors, IAccessPredicateNode } from '@/models';
import {
  convertLogicalExpressionTreeToPredicateNodeList,
  convertPredicateNodeListToLogicalExpressionTree
} from '@/models/predicate/tree';

import { useProxiedModel } from '@/composable/proxymodel';

import WorkflowFormBuilderAccessPredicateQueryTree from './WorkflowFormBuilderAccessPredicateQueryTree.vue';

export default defineComponent({
  name: 'WorkflowTransitionPredicateQueryTreeBuilder',

  components: {
    WorkflowFormBuilderAccessPredicateQueryTree
  },

  props: {
    value: {
      type: Array as PropType<IAccessPredicateNode[]>,
      required: true,
      default: () => []
    },
    fieldErrors: {
      type: Array as PropType<IFieldErrors[]>,
      default: (): IFieldErrors[] => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    sublabel: {
      type: String,
      default: ''
    }
  },

  setup(props) {
    const modelValue = useProxiedModel(
      props,
      'value',
      props.value,
      convertPredicateNodeListToLogicalExpressionTree,
      convertLogicalExpressionTreeToPredicateNodeList
    );

    return {
      modelValue
    };
  }
});
